import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface IMenuItem {
    id?: string;
    title?: string;
    description?: string;
    type: string;       // Possible values: link/dropDown/extLink
    name?: string;      // Used as display text for item and title for separator type
    state?: string;     // Router state
    icon?: string;      // Material icon name
    tooltip?: string;   // Tooltip text
    disabled?: boolean; // If true, item will not be appeared in sidenav.
    sub?: IChildItem[]; // Dropdown items
    badges?: IBadge[];
    active?: boolean;
}
export interface IChildItem {
    id?: string;
    parentId?: string;
    type?: string;
    name: string;       // Display text
    state?: string;     // Router state
    icon?: string;
    sub?: IChildItem[];
    active?: boolean;
}

interface IBadge {
    color: string;      // primary/accent/warn/hex color codes(#fff000)
    value: string;      // Display text
}

interface ISidebarState {
    sidenavOpen?: boolean;
    childnavOpen?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    public sidebarState: ISidebarState = {
        sidenavOpen: false,
        childnavOpen: false
    };
    selectedItem: IMenuItem;
    
    constructor() {
    }

    defaultMenu: IMenuItem[] = [
        {   
            name: 'Dashboard',
            description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
            type: 'dropDown',
            icon: 'i-Bar-Chart',
            sub: [
                { icon: 'i-Clock-3', name: 'Version 1', state: '/dashboard/v1', type: 'link' },
                { icon: 'i-Clock-4', name: 'Version 2', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Over-Time', name: 'Version 3', state: '/dashboard/v3', type: 'link' },
                { icon: 'i-Clock', name: 'Version 4', state: '/dashboard/v4', type: 'link' },
            ]
        },
        {
            name: 'Panel configuration',
            description: 'Configure settings and customize panel.',
            type: 'dropDown',
            icon: 'i-Gear-2',
            sub: [
                { icon: 'i-Gears', name: 'Settings', state: '/settings/config', type: 'link' }
            ]
        },
        {
            name: 'Partecipants Sourcing',
            description: 'Define sources and aggregates partecipants to this panel.',
            type: 'dropDown',
            icon: 'i-Find-User',
            sub: [
                { icon: 'i-Find-User', name: 'Monitor', state: '/sourcing/monitor', type: 'link' },
                { icon: 'i-Consulting', name: 'Recruitment', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Link-2', name: 'Static links', state: '/dashboard/v3', type: 'link' },
                { icon: 'i-Edit-Map', name: 'Upload...', state: '/dashboard/v4', type: 'link' },
            ]
        },
        {
            name: 'Partecipants',
            description: 'Monitor and extract panelists and interactions.',
            type: 'dropDown',
            icon: 'i-Business-Mens',
            sub: [
                { icon: 'i-Conference', name: 'List', state: '/sourcing/monitor', type: 'link' },
                { icon: 'i-Data-Center', name: 'Master Data', state: '/sourcing/monitor', type: 'link' },
                { icon: 'i-Receipt-4', name: 'Report', state: '/dashboard/v2', type: 'link' }
            ]
        },
        {
            name: 'Surveys',
            description: 'Define and manage surveys.',
            type: 'dropDown',
            icon: 'i-Check',
            sub: [
                { icon: 'i-Receipt-4', name: 'Compile', state: '/survey/compile', type: 'link' },
                // { icon: 'i-Conference', name: 'List', state: '/sourcing/monitor', type: 'link' },
                // { icon: 'i-Receipt-4', name: 'Report', state: '/dashboard/v2', type: 'link' },
                // { icon: 'i-Upload1', name: 'Upload data...', state: '/sourcing/monitor', type: 'link' }
            ]
        },
        {
            name: 'Orchestrator',
            description: 'Define common rules to manage events.',
            type: 'dropDown',
            icon: 'i-Shuffle-2',
            sub: [
                { icon: 'i-Over-Time', name: 'Master Schedule', state: '/sourcing/monitor', type: 'link' },
                { icon: 'i-Time-Window', name: 'Events', state: '/dashboard/v2', type: 'link' }
            ]
        },
        {
            name: 'Reports',
            description: 'Display reports and manage alerts.',
            type: 'dropDown',
            icon: 'i-Bar-Chart',
            sub: [
                { icon: 'i-Conference', name: 'List', state: '/dashboard/v1', type: 'link' },
                { icon: 'i-Download', name: 'Export data', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Gear', name: 'Configuration', state: '/dashboard/v2', type: 'link' }
            ]
        },
        {
            name: 'Portal',
            description: 'Configure the portal of partecipants.',
            type: 'dropDown',
            icon: 'i-URL-Window',
            sub: [
                { icon: 'i-Gear', name: 'Configuration', state: '/sourcing/monitor', type: 'link' },
                { icon: 'i-Brush', name: 'Themes', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Two-Windows', name: 'Pages', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Student-Hat-2', name: 'Faqs', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Receipt-3', name: 'Logs', state: '/dashboard/v2', type: 'link' }

            ]
        },
        {
            name: 'Rewards',
            description: 'Manage rewards and incentives.',
            type: 'dropDown',
            icon: 'i-Euro',
            sub: [
                { icon: 'i-Gear', name: 'Configure', state: '/sourcing/monitor', type: 'link' },
                { icon: 'i-Download', name: 'Export data', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Coins', name: 'Send incentives', state: '/dashboard/v2', type: 'link' }

            ]
        },
        {
            name: 'Communication Center',
            description: 'Send and receive communications.',
            type: 'dropDown',
            icon: 'i-Box-Full',
            sub: [
                { icon: 'i-Conference', name: 'Inbox', state: '/dashboard/v1', type: 'link' },
                { icon: 'i-Inbox-Out', name: 'Send', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Brush', name: 'Templates', state: '/dashboard/v2', type: 'link' },
                { icon: 'i-Gear', name: 'Configure', state: '/sourcing/monitor', type: 'link' }
            ]
        },
        {
            name: 'UI kits',
            description: 'Lorem ipsum dolor sit amet, consectetur adipisicing.',
            type: 'dropDown',
            icon: 'i-Library',
            sub: [
                { icon: 'i-Bell', name: 'Alerts', state: '/uikits/alerts', type: 'link' },
                { icon: 'i-Split-Horizontal-2-Window', name: 'Accordions', state: '/uikits/accordions', type: 'link' },
                { icon: 'i-Medal-2', name: 'Badges', state: '/uikits/badges', type: 'link' },
                {
                    icon: 'i-Arrow-Right-in-Circle',
                    name: 'Buttons',
                    type: 'dropDown',
                    sub: [
                        { name: 'Bootstrap Buttons', state: '/uikits/buttons', type: 'link' },
                        { name: 'Loding Buttons', state: '/uikits/buttons-loading', type: 'link' }
                    ]
                },
                { icon: 'i-ID-Card', name: 'Cards', state: '/uikits/cards', type: 'link' },
                { icon: 'i-Line-Chart-2', name: 'Cards metrics', state: '/uikits/cards-metrics', type: 'link' },
                { icon: 'i-Credit-Card', name: 'Cards widget', state: '/uikits/cards-widget', type: 'link' },
                { icon: 'i-Full-Cart', name: 'Cards ecommerce', state: '/uikits/cards-ecommerce', type: 'link' },
                { icon: 'i-Duplicate-Window', name: 'Modals', state: '/uikits/modals', type: 'link' },
                { icon: 'i-Speach-Bubble-3', name: 'Popover', state: '/uikits/popover', type: 'link' },
                { icon: 'i-Like', name: 'Rating', state: '/uikits/rating', type: 'link' },
                { icon: 'i-Loading-3', name: 'Loaders', state: '/uikits/loaders', type: 'link' },
            ]
        },
        {
            name: 'Apps',
            description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
            type: 'dropDown',
            icon: 'i-Computer-Secure',
            sub: [
                { icon: 'i-Add-File', name: 'Invoice Builder', state: '/invoice', type: 'link' },
                { icon: 'i-Email', name: 'Inbox', state: '/inbox', type: 'link' },
                { icon: 'i-Speach-Bubble-3', name: 'Chat', state: '/chat', type: 'link' },
                { icon: 'i-Calendar', name: 'Calendar', state: '/calendar', type: 'link' },
            ]
        },
        {
            name: 'Forms',
            description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
            type: 'dropDown',
            icon: 'i-File-Clipboard-File--Text',
            sub: [
                { icon: 'i-File-Clipboard-Text--Image', name: 'Basic components', state: '/forms/basic', type: 'link' },
                { icon: 'i-Split-Vertical', name: 'Form layouts', state: '/forms/layouts', type: 'link' },
                { icon: 'i-Receipt-4', name: 'Input Group', state: '/forms/input-group', type: 'link' },
                { icon: 'i-File-Edit', name: 'Input Mask', state: '/forms/input-mask', type: 'link' },
                { icon: 'i-Width-Window', name: 'Wizard', state: '/forms/wizard', type: 'link' },
                { icon: 'i-Crop-2', name: 'Image Cropper', state: '/forms/img-cropper', type: 'link' },
            ]
        },
        {
            name: 'Data Tables',
            description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
            type: 'dropDown',
            icon: 'i-File-Horizontal-Text',
            sub: [
                { icon: 'i-File-Horizontal-Text', name: 'List', state: '/tables/list', type: 'link' },
                { icon: 'i-Full-View-Window', name: 'Fullscreen', state: '/tables/full', type: 'link' },
                { icon: 'i-Code-Window', name: 'Paging', state: '/tables/paging', type: 'link' },
                { icon: 'i-Filter-2', name: 'Filter', state: '/tables/filter', type: 'link' },
            ]
        },
        {
            name: 'Sessions',
            description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
            type: 'dropDown',
            icon: 'i-Administrator',
            sub: [
                { icon: 'i-Add-User', name: 'Sign up', state: '/sessions/signup', type: 'link' },
                { icon: 'i-Checked-User', name: 'Sign in', state: '/sessions/signin', type: 'link' },
                { icon: 'i-Find-User', name: 'Forgot', state: '/sessions/forgot', type: 'link' }
            ]
        },
        {
            name: 'Pages',
            description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
            type: 'dropDown',
            icon: 'i-Windows-2',
            sub: [
                { icon: 'i-Male', name: 'User Profile', state: '/pages/profile', type: 'link' }
            ]
        },
        {
            name: 'Icons',
            description: '600+ premium icons',
            type: 'link',
            icon: 'i-Cloud-Sun',
            state: '/icons/iconsmind'
        },
        {
            name: 'Others',
            description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit.',
            type: 'dropDown',
            icon: 'i-Double-Tap',
            sub: [
                { icon: 'i-Error-404-Window', name: 'Not found', state: '/others/404', type: 'link' }
            ]
        },
        {
            name: 'Doc',
            type: 'extLink',
            tooltip: 'Documentation',
            icon: 'i-Safe-Box1',
            state: 'http://demos.ui-lib.com/gull-doc'
        }
    ];


    // sets iconMenu as default;
    menuItems = new BehaviorSubject<IMenuItem[]>(this.defaultMenu);
    // navigation component has subscribed to this Observable
    menuItems$ = this.menuItems.asObservable();

    // You can customize this method to supply different menu for
    // different user type.
    // publishNavigationChange(menuType: string) {
    //   switch (userType) {
    //     case 'admin':
    //       this.menuItems.next(this.adminMenu);
    //       break;
    //     case 'user':
    //       this.menuItems.next(this.userMenu);
    //       break;
    //     default:
    //       this.menuItems.next(this.defaultMenu);
    //   }
    // }
}
